module.exports = __webpack_public_path__ + "img/LI107349.5f0e6fe7.png";